import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const AccordionPanel = () => {
  const [open1, setOpen1] = useState(0);
  const [open2, setOpen2] = useState(-1);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* ACCORDION PANELS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Accordion Panels</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Accordion</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 space-y-2">
              {["Section 1", "Section 2", "Section 3"].map((sec, i) => (
                <div key={i} className="border border-slate-600 rounded overflow-hidden">
                  <button onClick={() => setOpen1(open1 === i ? -1 : i)} className="w-full text-left px-3 py-2 bg-slate-800 hover:bg-slate-700 text-sm text-slate-300 font-medium">{sec} {open1 === i ? "?" : "?"}</button>
                  {open1 === i && <div className="px-3 py-2 bg-slate-900 text-xs text-slate-400">Content for {sec} goes here</div>}
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [open, setOpen] = useState(-1);

{items.map((item, i) => (
  <div key={i} className="border rounded">
    <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full text-left px-4 py-2">
      {item} {open === i ? '?' : '?'}
    </button>
    {open === i && <div className="p-4 bg-slate-900">{content}</div>}
  </div>
))}`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Styled Accordion</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 space-y-2">
              {[{title: "Features", icon: "?"}, {title: "Pricing", icon: "??"}, {title: "Support", icon: "??"}].map((item, i) => (
                <div key={i}>
                  <button onClick={() => setOpen2(open2 === i ? -1 : i)} className={`w-full text-left px-3 py-2 rounded flex items-center gap-2 text-sm font-medium ${open2 === i ? "bg-amber-600 text-white" : "bg-slate-800 text-slate-300 hover:bg-slate-700"}`}>{item.icon} {item.title}</button>
                  {open2 === i && <div className="px-3 py-2 bg-slate-800 text-xs text-slate-400 mt-1 rounded">Details about {item.title}</div>}
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`{items.map((item, i) => (
  <button key={i} onClick={() => setOpen(i)} className={open === i ? "bg-amber-600" : "bg-slate-800"}>
    {item.icon} {item.title}
  </button>
))}`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Smooth Animation</label>
            <div className="p-2 bg-slate-950 rounded border border-slate-600 space-y-1">
              {["Q: What is this?", "Q: How to use?", "Q: Any costs?"].map((q, i) => (
                <div key={i} className="border border-slate-600 rounded">
                  <button className="w-full text-left px-3 py-2 text-sm text-slate-300 hover:bg-slate-800">{q}</button>
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="transition-all duration-300">
  {open && (
    <div className="overflow-hidden animate-slideDown">
      {content}
    </div>
  )}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Multi-level</label>
            <div className="p-2 bg-slate-950 rounded border border-slate-600 space-y-1 text-xs">
              <div className="px-2 py-1 font-medium text-slate-300">Category 1 ?</div>
              <div className="pl-4 space-y-1 text-slate-400">
                <div>Item 1.1</div>
                <div>Item 1.2</div>
              </div>
              <div className="px-2 py-1 font-medium text-slate-300">Category 2 ?</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-1">
  {categories.map(cat => (
    <div key={cat}>
      <button onClick={() => toggle(cat)}>{cat}</button>
      {expanded === cat && (
        <div className="pl-4">
          {items[cat].map(i => <p key={i}>{i}</p>)}
        </div>
      )}
    </div>
  ))}
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED PANELS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Nested Accordion</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 space-y-2 text-sm">
              <div className="border border-slate-600 rounded">
                <button className="w-full text-left px-3 py-2 bg-slate-800 text-slate-300">Main Category ?</button>
                <div className="pl-4 space-y-1 bg-slate-900 p-2">
                  <button className="block w-full text-left px-2 py-1 text-slate-400 hover:text-slate-200">Subcategory A</button>
                  <button className="block w-full text-left px-2 py-1 text-slate-400 hover:text-slate-200">Subcategory B</button>
                </div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`// Recursive accordion component
const AccordionItem = ({ item, level = 0 }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{paddingLeft: level * 16}}>
      <button onClick={() => setOpen(!open)}>{item.title}</button>
      {open && item.children?.map(child => <AccordionItem key={child} item={child} level={level + 1} />)}
    </div>
  );
};`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionPanel;


